// extracted by mini-css-extract-plugin
var _1 = "FilePreviewContainer-moduleFilePreviewContainer__wJEAE";
export { _1 as "FilePreviewContainer" }
